module.exports = __webpack_public_path__ + "media/images/responsive/page_common/banner/banner-onlinesupport@3x-a57328330dd298a055e42085cbc8b041.webp";